import { useState, useEffect } from 'react';
import settingsService from '../services/settings.service';
import { SettingCategory } from '../types/settings.types';

/**
 * Hook to get the current time format preference
 * @returns {boolean} Whether to use 24-hour format
 */
export function useTimeFormat(): boolean {
  const [use24Hour, setUse24Hour] = useState(false);

  useEffect(() => {
    const loadTimeFormat = async () => {
      try {
        const cats = await settingsService.getSettingsByCategory();
        // Find the TIME_FORMAT_24_HOUR setting
        const uiSettings = cats.find(cat => cat.category === SettingCategory.UI);
        if (uiSettings) {
          const timeFormatSetting = uiSettings.settings.find(
            s => s.key === 'TIME_FORMAT_24_HOUR'
          );
          if (timeFormatSetting) {
            setUse24Hour(timeFormatSetting.value === 'true');
          }
        }
      } catch (error) {
        console.error('Failed to load time format setting:', error);
      }
    };

    loadTimeFormat();
  }, []);

  return use24Hour;
}